import axios from "axios";

export default {
	async products() {
		return await axios.get("/products/dashboard");
	},

	async getPromotion() {
		return await axios.get("/promo_push_ups");
	},

	async getSpecialOffer() {
		return await axios.get("/active_special_offer");
	},
};
